import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { CardDate } from '../CardDate';

var CardExpiry = props => React.createElement(CardDate, _extends({}, props, {
  autoComplete: "cc-exp",
  cardDateType: "expiry"
}));

CardExpiry.defaultProps = {
  id: 'cardExpiry',
  name: 'exp-date',
  required: true
};
export { CardExpiry };